import { ehProdutoAdicionais } from "../componentes/CardapioContext"

// Exportação do cardápio para CSV no layout do sistemaadm
// (CardapioService.gerarCabecalho / exportarConteudoCardapio), acrescido das colunas
// Id, Versao, FichaTecnicaId e FichaTecnicaNome ao final para permitir reimportação
// com upsert por id e referência à ficha técnica.

const SEP = ";"
const EOL = "\r\n"
const BOM = "﻿"

// Ordem das colunas (idêntica ao gerarCabecalho do backend) + colunas novas no fim.
const CABECALHO = [
    "Tipo",
    "Nome",
    "Descrição",
    "Preço",
    "Codigo",
    "Qtd. Minima",
    "Qtd. Máxima",
    "Considerar Maior Valor?",
    "Disponível?",
    "Dia da Semana",
    "Turno",
    "Permite Observação?",
    "Url Foto",
    "Pontos",
    "Valor Domingo",
    "Valor Segunda",
    "Valor Terça",
    "Valor Quarta",
    "Valor Quinta",
    "Valor Sexta",
    "Valor Sábado",
    "Disponível Domingo",
    "Disponível Segunda",
    "Disponível Terça",
    "Disponível Quarta",
    "Disponível Quinta",
    "Disponível Sexta",
    "Disponível Sábado",
    "É Promocional?",
    "Apenas Informativo",
    "É Pizza?",
    "Considerar Média",
    "Apenas Primeira Compra",
    "Grupo Opção Associado",
    "Impressora",
    "Multiplicador Adição",
    // Colunas novas (não existem no backend):
    "Id",
    "Versao",
    "FichaTecnicaId",
    "FichaTecnicaNome",
]

const TOTAL_COLUNAS = CABECALHO.length

// Índice da coluna pelo nome (para preencher só o que faz sentido por tipo de linha).
const COL = CABECALHO.reduce((acc, nome, i) => {
    acc[nome] = i
    return acc
}, {})

const sn = v => (v ? "Sim" : "Não")
const txt = v => (v === null || v === undefined ? "" : String(v))

// adicional (0..3) -> letra do grupo, conforme preencherObjetos do backend.
function letraGrupo(adicional) {
    switch (Number(adicional)) {
        case 1:
            return "GA"
        case 2:
            return "GQ"
        case 3:
            return "GD"
        default:
            return "GO"
    }
}

// Escapa um campo no padrão RFC-4180 (aspas duplicadas, envolve em aspas se necessário).
function escapar(valor) {
    const s = txt(valor)
    if (s.includes('"') || s.includes(SEP) || s.includes("\n") || s.includes("\r")) {
        return '"' + s.replace(/"/g, '""') + '"'
    }
    return s
}

function novaLinha() {
    return new Array(TOTAL_COLUNAS).fill("")
}

// Índice id-do-item -> {id, nome} da ficha técnica, a partir de FTEstabelecimento.
function indexarFichas(fichas) {
    const porProduto = new Map()
    const porOpcao = new Map()
    ;(fichas ?? []).forEach(ficha => {
        const vinc = ficha?.vinculos ?? {}
        ;(vinc.produto_ids ?? []).forEach(id => porProduto.set(id, ficha))
        ;(vinc.opcaoIds ?? []).forEach(id => porOpcao.set(id, ficha))
    })
    return { porProduto, porOpcao }
}

function linhaCategoria(categoria) {
    const l = novaLinha()
    l[COL["Tipo"]] = "C"
    l[COL["Nome"]] = txt(categoria.nome)
    l[COL["Qtd. Minima"]] = txt(categoria.quantidadeMinima)
    l[COL["Qtd. Máxima"]] = txt(categoria.quantidadeMaxima)
    l[COL["Disponível?"]] = sn(categoria.ativo)
    l[COL["Dia da Semana"]] = txt(categoria.diaSemana)
    l[COL["Turno"]] = txt(categoria.turnoProduto)
    l[COL["Id"]] = txt(categoria.id)
    l[COL["Versao"]] = txt(categoria.versao)
    return l
}

function linhaProduto(produto, fichaProduto) {
    const l = novaLinha()
    const disp = produto.disponibilidadeProduto ?? {}
    l[COL["Tipo"]] = "P"
    l[COL["Nome"]] = txt(produto.nome)
    l[COL["Descrição"]] = txt(produto.descricao)
    l[COL["Preço"]] = txt(produto.valor)
    l[COL["Codigo"]] = txt(produto.codigo)
    l[COL["Disponível?"]] = sn(produto.ativo)
    l[COL["Dia da Semana"]] = txt(produto.diaSemana)
    l[COL["Turno"]] = txt(produto.turnoProduto)
    l[COL["Permite Observação?"]] = sn(produto.permiteObservacao)
    l[COL["Url Foto"]] = txt(produto.urlImagem)
    l[COL["Pontos"]] = txt(produto.pontos)
    l[COL["Valor Domingo"]] = txt(disp.valorDomingo)
    l[COL["Valor Segunda"]] = txt(disp.valorSegunda)
    l[COL["Valor Terça"]] = txt(disp.valorTerca)
    l[COL["Valor Quarta"]] = txt(disp.valorQuarta)
    l[COL["Valor Quinta"]] = txt(disp.valorQuinta)
    l[COL["Valor Sexta"]] = txt(disp.valorSexta)
    l[COL["Valor Sábado"]] = txt(disp.valorSabado)
    l[COL["Disponível Domingo"]] = sn(disp.disponivelDomingo)
    l[COL["Disponível Segunda"]] = sn(disp.disponivelSegunda)
    l[COL["Disponível Terça"]] = sn(disp.disponivelTerca)
    l[COL["Disponível Quarta"]] = sn(disp.disponivelQuarta)
    l[COL["Disponível Quinta"]] = sn(disp.disponivelQuinta)
    l[COL["Disponível Sexta"]] = sn(disp.disponivelSexta)
    l[COL["Disponível Sábado"]] = sn(disp.disponivelSabado)
    l[COL["É Promocional?"]] = sn(produto.promocional)
    l[COL["Apenas Informativo"]] = sn(produto.produtoExibicao)
    l[COL["Apenas Primeira Compra"]] = sn(produto.apenasPrimeiraCompra)
    l[COL["Impressora"]] = txt(produto.impressaoAlternada || "")
    l[COL["Id"]] = txt(produto.id)
    l[COL["Versao"]] = txt(produto.versao)
    l[COL["FichaTecnicaId"]] = txt(fichaProduto?.id)
    l[COL["FichaTecnicaNome"]] = txt(fichaProduto?.nome)
    return l
}

function linhaGrupo(grupo) {
    const l = novaLinha()
    l[COL["Tipo"]] = letraGrupo(grupo.adicional)
    l[COL["Nome"]] = txt(grupo.nome)
    l[COL["Qtd. Minima"]] = txt(grupo.quantidadeMinima)
    l[COL["Qtd. Máxima"]] = txt(grupo.quantidadeMaxima)
    l[COL["Considerar Maior Valor?"]] = sn(grupo.considerarMaiorValor)
    l[COL["Disponível?"]] = sn(grupo.ativo)
    l[COL["Dia da Semana"]] = txt(grupo.diaSemana)
    l[COL["É Pizza?"]] = sn(Number(grupo.tipo) === 1)
    l[COL["Considerar Média"]] = sn(grupo.considerarMedia)
    l[COL["Id"]] = txt(grupo.id)
    l[COL["Versao"]] = txt(grupo.versao)
    return l
}

function linhaOpcao(opcao, fichaOpcao) {
    const l = novaLinha()
    l[COL["Tipo"]] = "O"
    l[COL["Nome"]] = txt(opcao.nome)
    l[COL["Descrição"]] = txt(opcao.descricao)
    l[COL["Preço"]] = txt(opcao.valor)
    l[COL["Codigo"]] = txt(opcao.codigo)
    l[COL["Disponível?"]] = sn(opcao.ativo)
    l[COL["Apenas Informativo"]] = sn(opcao.informativo)
    l[COL["Impressora"]] = txt(opcao.impressaoAlternada || "")
    l[COL["Url Foto"]] = txt(opcao.urlImagem)
    l[COL["Id"]] = txt(opcao.id)
    l[COL["Versao"]] = txt(opcao.versao)
    l[COL["FichaTecnicaId"]] = txt(fichaOpcao?.id)
    l[COL["FichaTecnicaNome"]] = txt(fichaOpcao?.nome)
    return l
}

// Gera o texto CSV completo (sem BOM). categorias = estado do CardapioContext;
// fichas = FTEstabelecimento (para resolver a referência de ficha técnica).
export function gerarCsvCardapio(categorias, fichas) {
    const { porProduto, porOpcao } = indexarFichas(fichas)
    const linhas = [CABECALHO.slice()]

    ;(categorias ?? []).forEach(categoria => {
        linhas.push(linhaCategoria(categoria))
        ;(categoria.produtos ?? [])
            .filter(prod => !ehProdutoAdicionais(prod))
            .slice()
            .sort((a, b) => (a.ordemExib ?? 0) - (b.ordemExib ?? 0))
            .forEach(produto => {
                linhas.push(linhaProduto(produto, porProduto.get(produto.id)))
                ;(produto.opcoes ?? [])
                    .slice()
                    .sort((a, b) => (a.ordemExib ?? 0) - (b.ordemExib ?? 0))
                    .forEach(grupo => {
                        linhas.push(linhaGrupo(grupo))
                        ;(grupo.opcoes ?? [])
                            .slice()
                            .sort((a, b) => (a.ordemExib ?? 0) - (b.ordemExib ?? 0))
                            .forEach(opcao => {
                                linhas.push(linhaOpcao(opcao, porOpcao.get(opcao.id)))
                            })
                    })
            })
    })

    return linhas.map(cols => cols.map(escapar).join(SEP)).join(EOL)
}

// Dispara o download do CSV (UTF-8 com BOM, padrão Windows/Excel).
export function baixarCsvCardapio(categorias, fichas, nomeArquivo = "cardapio.csv") {
    const conteudo = gerarCsvCardapio(categorias, fichas)
    const blob = new Blob([BOM + conteudo], { type: "text/csv;charset=utf-8;" })
    const url = URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = url
    link.download = nomeArquivo
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
}
